export default __webpack_public_path__ + "static/media/gr-home.699dbe80.svg";